var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 793,
    height: 152,
    viewBox: "0 0 793 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4679_872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1339 89.7886C43.9 73.6232 55.2176 58.7447 60.5591 52.7888L64.5731 48.7422C65.9391 47.365 66.1583 45.1755 64.8728 43.7217C63.4843 42.1515 61.0977 42.2703 59.6222 43.7578L48.6596 54.8096C48.6406 54.8287 48.6218 54.8477 48.6029 54.8668L48.5845 54.8854C48.4597 55.012 48.3358 55.1391 48.2129 55.2669L48.176 55.3054C48.1562 55.3259 48.1365 55.3465 48.1169 55.3671C48.0999 55.3849 48.0829 55.4027 48.066 55.4205C47.9134 55.5808 47.7624 55.742 47.6129 55.9042C46.7287 56.8637 45.899 57.8557 45.1238 58.8763C37.8151 67.8713 34.7417 77.2181 33.863 85.6268C31.5593 84.3196 29.3774 82.7145 27.3728 80.8117C27.3291 80.765 27.284 80.7193 27.2374 80.6746C22.0607 75.7087 18.6049 69.1965 17.3799 62.0992C16.155 55.002 17.2259 47.6957 20.4345 41.2589C23.6431 34.8221 28.8194 29.5958 35.1994 26.3514C39.7213 24.0518 44.6781 22.8342 49.689 22.756C50.0564 22.7503 50.4238 22.7506 50.7912 22.7571C52.485 22.7872 54.1818 22.9475 55.8669 23.2405C62.9087 24.4647 69.3736 27.9388 74.3073 33.15C79.241 38.3613 82.382 45.0335 83.2669 52.182C84.1517 59.3304 82.7334 66.5763 79.2214 72.85C75.7093 79.1237 70.2896 84.093 63.7621 87.0242C63.6784 87.0618 63.5968 87.1024 63.5174 87.1457C58.3277 89.4214 52.679 90.3024 47.1339 89.7886Z",
    fill: "#892CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7617 122.565C60.7703 113.953 49.5467 100.468 47.2894 90.5184C43.6222 74.3545 54.7444 59.3572 60.2746 53.1079L76.9422 36.2995C80.3615 40.9356 82.5513 46.4032 83.2666 52.182C84.1514 59.3304 82.7332 66.5762 79.2211 72.85C75.7091 79.1237 70.2893 84.093 63.7619 87.0242C61.9969 87.8168 61.2035 89.9017 61.9896 91.681C62.7758 93.4603 64.8439 94.2602 66.6089 93.4676C70.6815 91.6387 74.3979 89.1542 77.6251 86.1356C78.4573 85.3572 79.2569 84.5433 80.0218 83.696C105.812 56.6406 93.2006 32.887 88.9197 26.4691C101.454 19.9567 117.235 22.0033 127.738 32.5948C140.743 45.7099 140.756 66.9868 127.751 80.1018L77.1925 131.077L68.7617 122.565Z",
    fill: "#3DCEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5813 48.734C64.5785 48.7368 64.5756 48.7397 64.5728 48.7426L60.5588 52.7892C55.2151 58.7475 43.8904 73.6359 47.1377 89.8091C48.1477 89.9021 49.1707 89.9497 50.2047 89.9497C54.8961 89.9497 59.3623 88.9709 63.4132 87.2051C63.5247 87.1392 63.641 87.0789 63.7619 87.0246C70.2893 84.0934 75.709 79.1242 79.2211 72.8504C82.7332 66.5767 84.1514 59.3308 83.2666 52.1824C82.5505 46.3971 80.3566 40.9237 76.9306 36.2842L64.5813 48.734Z",
    fill: "#1E88F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.644 84.5561V32.8861H192.745L194.258 39.3818C199.171 35.0514 204.524 32.8861 210.315 32.8861C217.734 32.8861 222.794 35.2482 225.495 39.9723C231.059 35.2482 236.704 32.8861 242.431 32.8861C254.21 32.8861 260.1 39.431 260.1 52.5207V84.5561H251.07V52.0286C251.07 44.3191 247.849 40.4644 241.406 40.4644C236.591 40.4644 232.084 42.6952 227.886 47.1569V84.5561H218.857V52.1763C218.857 44.3684 215.668 40.4644 209.291 40.4644C204.214 40.4644 199.675 42.6952 195.673 47.1569V84.5561H186.644Z",
    fill: "url(#paint0_linear_4679_872)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.925 32.8861C310.502 32.8861 317.791 40.1527 317.791 54.6859C317.791 56.7527 317.644 58.9672 317.352 61.3292H281.38C281.38 71.8929 287.497 77.1747 299.732 77.1747C305.556 77.1747 310.73 76.5186 315.253 75.2063V82.5877C310.73 83.9 305.231 84.5561 298.756 84.5561C281.152 84.5561 272.351 75.7476 272.351 58.1306C272.351 41.301 280.209 32.8861 295.925 32.8861ZM281.38 53.751H309.103C308.908 44.6964 304.515 40.1691 295.925 40.1691C286.814 40.1691 281.966 44.6964 281.38 53.751Z",
    fill: "url(#paint1_linear_4679_872)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M329.944 84.5561V32.8861H336.045L337.656 39.4802C342.895 35.0842 348.654 32.8861 354.934 32.8861C367.722 32.8861 374.115 39.2998 374.115 52.127V84.5561H365.086V51.9794C365.086 44.3027 361.295 40.4644 353.714 40.4644C348.54 40.4644 343.627 42.646 338.974 47.0093V84.5561H329.944Z",
    fill: "url(#paint2_linear_4679_872)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M388.807 24.5205H394.468L396.421 32.8861H410.282V40.2676H397.836V69.9409C397.836 74.7634 399.902 77.1747 404.035 77.1747H410.282V84.5561H401.692C393.102 84.5561 388.807 79.914 388.807 70.6298V24.5205Z",
    fill: "url(#paint3_linear_4679_872)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M419.361 68.9567C419.361 58.3603 426.291 53.062 440.153 53.062C444.611 53.062 449.068 53.3901 453.526 54.0462V49.1745C453.526 43.2365 448.922 40.2676 439.714 40.2676C434.442 40.2676 429.041 41.0877 423.509 42.728V35.3466C429.041 33.7063 434.442 32.8861 439.714 32.8861C454.942 32.8861 462.556 38.2336 462.556 48.9284V84.5561H457.48L454.356 79.4383C449.247 82.8502 443.683 84.5561 437.664 84.5561C425.462 84.5561 419.361 79.3563 419.361 68.9567ZM440.153 60.4435C432.311 60.4435 428.39 63.232 428.39 68.8091C428.39 74.3861 431.481 77.1747 437.664 77.1747C443.911 77.1747 449.199 75.5016 453.526 72.1553V61.4276C449.068 60.7715 444.611 60.4435 440.153 60.4435Z",
    fill: "url(#paint4_linear_4679_872)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M486.765 14.1865V84.5561H477.735V14.1865H486.765Z",
    fill: "url(#paint5_linear_4679_872)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M564.906 83.0798C560.676 84.064 556.121 84.5561 551.24 84.5561C533.018 84.5561 523.908 75.6164 523.908 57.7369C523.908 41.1697 533.018 32.8861 551.24 32.8861C556.121 32.8861 560.676 33.3782 564.906 34.3624V41.7438C560.676 40.7597 555.958 40.2676 550.752 40.2676C538.875 40.2676 532.937 46.0907 532.937 57.7369C532.937 70.6954 538.875 77.1747 550.752 77.1747C555.958 77.1747 560.676 76.6826 564.906 75.6984V83.0798Z",
    fill: "url(#paint6_linear_4679_872)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M585.943 14.1865V84.5561H576.913V14.1865H585.943Z",
    fill: "url(#paint7_linear_4679_872)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M611.128 32.8861V84.5561H602.098V32.8861H611.128ZM611.128 14.1865V22.7982H602.098V14.1865H611.128Z",
    fill: "url(#paint8_linear_4679_872)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M626.795 84.5561V32.8861H632.896L634.507 39.4802C639.745 35.0842 645.505 32.8861 651.785 32.8861C664.572 32.8861 670.966 39.2998 670.966 52.127V84.5561H661.937V51.9794C661.937 44.3027 658.146 40.4644 650.565 40.4644C645.391 40.4644 640.478 42.646 635.824 47.0093V84.5561H626.795Z",
    fill: "url(#paint9_linear_4679_872)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M695.663 32.8861V84.5561H686.634V32.8861H695.663ZM695.663 14.1865V22.7982H686.634V14.1865H695.663Z",
    fill: "url(#paint10_linear_4679_872)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M749.889 83.0798C745.659 84.064 741.104 84.5561 736.223 84.5561C718.001 84.5561 708.89 75.6164 708.89 57.7369C708.89 41.1697 718.001 32.8861 736.223 32.8861C741.104 32.8861 745.659 33.3782 749.889 34.3624V41.7438C745.659 40.7597 740.941 40.2676 735.735 40.2676C723.858 40.2676 717.92 46.0907 717.92 57.7369C717.92 70.6954 723.858 77.1747 735.735 77.1747C740.941 77.1747 745.659 76.6826 749.889 75.6984V83.0798Z",
    fill: "url(#paint11_linear_4679_872)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M202.169 108.855V111.094H196.691V124.526H193.952V111.094H188.475V108.855H202.169Z",
    fill: "url(#paint12_linear_4679_872)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M202.169 108.855V111.094H196.691V124.526H193.952V111.094H188.475V108.855H202.169Z",
    fill: "#1F1F1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.664 122.288C223.204 122.288 223.974 121.492 223.974 119.9C223.974 118.407 222.774 117.661 220.376 117.661H219.192V115.855C222.251 115.507 223.781 114.467 223.781 112.736C223.781 111.641 223.149 111.094 221.886 111.094H216.142V122.288H221.664ZM213.403 124.526V108.855H222.138C225.178 108.855 226.698 110.163 226.698 112.78C226.698 114.402 225.73 115.606 223.796 116.392C225.908 116.92 226.964 118.074 226.964 119.855C226.964 122.969 225.252 124.526 221.827 124.526H213.403Z",
    fill: "url(#paint13_linear_4679_872)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.664 122.288C223.204 122.288 223.974 121.492 223.974 119.9C223.974 118.407 222.774 117.661 220.376 117.661H219.192V115.855C222.251 115.507 223.781 114.467 223.781 112.736C223.781 111.641 223.149 111.094 221.886 111.094H216.142V122.288H221.664ZM213.403 124.526V108.855H222.138C225.178 108.855 226.698 110.163 226.698 112.78C226.698 114.402 225.73 115.606 223.796 116.392C225.908 116.92 226.964 118.074 226.964 119.855C226.964 122.969 225.252 124.526 221.827 124.526H213.403Z",
    fill: "#1F1F1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M238.924 116.691C238.924 111.367 241.49 108.706 246.622 108.706C251.754 108.706 254.32 111.367 254.32 116.691C254.32 122.014 251.754 124.675 246.622 124.675C241.51 124.675 238.944 122.014 238.924 116.691ZM241.663 116.631C241.663 120.501 243.316 122.437 246.622 122.437C249.928 122.437 251.582 120.501 251.582 116.631C251.582 112.84 249.928 110.945 246.622 110.945C243.316 110.945 241.663 112.84 241.663 116.631Z",
    fill: "url(#paint14_linear_4679_872)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M238.924 116.691C238.924 111.367 241.49 108.706 246.622 108.706C251.754 108.706 254.32 111.367 254.32 116.691C254.32 122.014 251.754 124.675 246.622 124.675C241.51 124.675 238.944 122.014 238.924 116.691ZM241.663 116.631C241.663 120.501 243.316 122.437 246.622 122.437C249.928 122.437 251.582 120.501 251.582 116.631C251.582 112.84 249.928 110.945 246.622 110.945C243.316 110.945 241.663 112.84 241.663 116.631Z",
    fill: "#1F1F1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M276.791 124.526V111.139H271.491C270.129 111.139 269.448 111.726 269.448 112.9C269.448 114.293 271.028 115.313 274.186 115.959V117.915L268.634 124.526H265.17L271.181 117.526C268.081 116.561 266.532 115.029 266.532 112.93C266.532 110.213 268.2 108.855 271.536 108.855H279.53V124.526H276.791Z",
    fill: "url(#paint15_linear_4679_872)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M276.791 124.526V111.139H271.491C270.129 111.139 269.448 111.726 269.448 112.9C269.448 114.293 271.028 115.313 274.186 115.959V117.915L268.634 124.526H265.17L271.181 117.526C268.081 116.561 266.532 115.029 266.532 112.93C266.532 110.213 268.2 108.855 271.536 108.855H279.53V124.526H276.791Z",
    fill: "#1F1F1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M319.972 124.526L317.795 120.855C316.335 118.397 314.923 117.168 313.561 117.168V115.332C315.14 115.332 316.315 114.253 317.085 112.094C317.864 109.935 319.182 108.855 321.038 108.855H322.622V111.243H321.452C320.386 111.243 319.602 111.974 319.098 113.437C318.595 114.89 317.726 115.86 316.493 116.347C317.657 116.556 319.054 117.969 320.682 120.586L323.14 124.526H319.972ZM312.125 108.855V124.526H309.386V108.855H312.125Z",
    fill: "url(#paint16_linear_4679_872)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M319.972 124.526L317.795 120.855C316.335 118.397 314.923 117.168 313.561 117.168V115.332C315.14 115.332 316.315 114.253 317.085 112.094C317.864 109.935 319.182 108.855 321.038 108.855H322.622V111.243H321.452C320.386 111.243 319.602 111.974 319.098 113.437C318.595 114.89 317.726 115.86 316.493 116.347C317.657 116.556 319.054 117.969 320.682 120.586L323.14 124.526H319.972ZM312.125 108.855V124.526H309.386V108.855H312.125Z",
    fill: "#1F1F1F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M332.509 122.288C334.848 122.288 336.017 120.944 336.017 118.258V108.855H347.861V124.526H345.122V111.094H338.756V118.258C338.756 122.437 336.674 124.526 332.509 124.526V122.288Z",
    fill: "url(#paint17_linear_4679_872)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M332.509 122.288C334.848 122.288 336.017 120.944 336.017 118.258V108.855H347.861V124.526H345.122V111.094H338.756V118.258C338.756 122.437 336.674 124.526 332.509 124.526V122.288Z",
    fill: "#1F1F1F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M364.351 108.855V124.526H361.612V108.855H364.351ZM364.351 103.184V105.795H361.612V103.184H364.351Z",
    fill: "url(#paint18_linear_4679_872)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M364.351 108.855V124.526H361.612V108.855H364.351ZM364.351 103.184V105.795H361.612V103.184H364.351Z",
    fill: "#1F1F1F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M378.102 124.526V108.855H380.841V115.422H389.057V108.855H391.796V124.526H389.057V117.661H380.841V124.526H378.102Z",
    fill: "url(#paint19_linear_4679_872)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M378.102 124.526V108.855H380.841V115.422H389.057V108.855H391.796V124.526H389.057V117.661H380.841V124.526H378.102Z",
    fill: "#1F1F1F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M408.286 108.855V124.526H405.547V108.855H408.286ZM408.286 103.184V105.795H405.547V103.184H408.286Z",
    fill: "url(#paint20_linear_4679_872)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M408.286 108.855V124.526H405.547V108.855H408.286ZM408.286 103.184V105.795H405.547V103.184H408.286Z",
    fill: "#1F1F1F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M432.623 124.526L430.446 120.855C428.986 118.397 427.574 117.168 426.212 117.168V115.332C427.791 115.332 428.966 114.253 429.736 112.094C430.515 109.935 431.833 108.855 433.688 108.855H435.273V111.243H434.103C433.037 111.243 432.252 111.974 431.749 113.437C431.246 114.89 430.377 115.86 429.143 116.347C430.308 116.556 431.705 117.969 433.333 120.586L435.791 124.526H432.623ZM424.776 108.855V124.526H422.037V108.855H424.776Z",
    fill: "url(#paint21_linear_4679_872)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M432.623 124.526L430.446 120.855C428.986 118.397 427.574 117.168 426.212 117.168V115.332C427.791 115.332 428.966 114.253 429.736 112.094C430.515 109.935 431.833 108.855 433.688 108.855H435.273V111.243H434.103C433.037 111.243 432.252 111.974 431.749 113.437C431.246 114.89 430.377 115.86 429.143 116.347C430.308 116.556 431.705 117.969 433.333 120.586L435.791 124.526H432.623ZM424.776 108.855V124.526H422.037V108.855H424.776Z",
    fill: "#1F1F1F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M446.64 119.795C446.64 116.581 448.742 114.974 452.947 114.974C454.299 114.974 455.651 115.074 457.003 115.273V113.795C457.003 111.994 455.607 111.094 452.814 111.094C451.215 111.094 449.576 111.343 447.898 111.84V109.601C449.576 109.104 451.215 108.855 452.814 108.855C457.433 108.855 459.742 110.477 459.742 113.721V124.526H458.202L457.255 122.974C455.705 124.009 454.018 124.526 452.192 124.526C448.491 124.526 446.64 122.949 446.64 119.795ZM452.947 117.213C450.568 117.213 449.379 118.059 449.379 119.75C449.379 121.442 450.317 122.288 452.192 122.288C454.087 122.288 455.691 121.78 457.003 120.765V117.512C455.651 117.313 454.299 117.213 452.947 117.213Z",
    fill: "url(#paint22_linear_4679_872)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M446.64 119.795C446.64 116.581 448.742 114.974 452.947 114.974C454.299 114.974 455.651 115.074 457.003 115.273V113.795C457.003 111.994 455.607 111.094 452.814 111.094C451.215 111.094 449.576 111.343 447.898 111.84V109.601C449.576 109.104 451.215 108.855 452.814 108.855C457.433 108.855 459.742 110.477 459.742 113.721V124.526H458.202L457.255 122.974C455.705 124.009 454.018 124.526 452.192 124.526C448.491 124.526 446.64 122.949 446.64 119.795ZM452.947 117.213C450.568 117.213 449.379 118.059 449.379 119.75C449.379 121.442 450.317 122.288 452.192 122.288C454.087 122.288 455.691 121.78 457.003 120.765V117.512C455.651 117.313 454.299 117.213 452.947 117.213Z",
    fill: "#1F1F1F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M487.748 108.855H490.723L495.12 121.094L499.665 108.855H502.567L496.112 124.989C494.967 127.835 493.25 129.611 490.96 130.317L489.909 128.362C491.646 127.596 492.91 126.347 493.699 124.616L487.748 108.855Z",
    fill: "url(#paint23_linear_4679_872)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M487.748 108.855H490.723L495.12 121.094L499.665 108.855H502.567L496.112 124.989C494.967 127.835 493.25 129.611 490.96 130.317L489.909 128.362C491.646 127.596 492.91 126.347 493.699 124.616L487.748 108.855Z",
    fill: "#1F1F1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M542.239 124.079C540.955 124.377 539.574 124.526 538.093 124.526C532.566 124.526 529.803 121.815 529.803 116.392C529.803 111.367 532.566 108.855 538.093 108.855C539.574 108.855 540.955 109.004 542.239 109.303V111.542C540.955 111.243 539.524 111.094 537.945 111.094C534.343 111.094 532.542 112.86 532.542 116.392C532.542 120.322 534.343 122.288 537.945 122.288C539.524 122.288 540.955 122.138 542.239 121.84V124.079Z",
    fill: "url(#paint24_linear_4679_872)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M542.239 124.079C540.955 124.377 539.574 124.526 538.093 124.526C532.566 124.526 529.803 121.815 529.803 116.392C529.803 111.367 532.566 108.855 538.093 108.855C539.574 108.855 540.955 109.004 542.239 109.303V111.542C540.955 111.243 539.524 111.094 537.945 111.094C534.343 111.094 532.542 112.86 532.542 116.392C532.542 120.322 534.343 122.288 537.945 122.288C539.524 122.288 540.955 122.138 542.239 121.84V124.079Z",
    fill: "#1F1F1F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M554.731 124.526V108.855H558.21L563.466 121.288L568.573 108.855H571.904V124.526H569.462V112.542L564.458 124.526H562.296L557.174 112.542V124.526H554.731Z",
    fill: "url(#paint25_linear_4679_872)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M554.731 124.526V108.855H558.21L563.466 121.288L568.573 108.855H571.904V124.526H569.462V112.542L564.458 124.526H562.296L557.174 112.542V124.526H554.731Z",
    fill: "#1F1F1F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M584.604 119.795C584.604 116.581 586.707 114.974 590.911 114.974C592.263 114.974 593.615 115.074 594.968 115.273V113.795C594.968 111.994 593.571 111.094 590.778 111.094C589.179 111.094 587.541 111.343 585.863 111.84V109.601C587.541 109.104 589.179 108.855 590.778 108.855C595.397 108.855 597.706 110.477 597.706 113.721V124.526H596.167L595.219 122.974C593.67 124.009 591.982 124.526 590.156 124.526C586.455 124.526 584.604 122.949 584.604 119.795ZM590.911 117.213C588.533 117.213 587.343 118.059 587.343 119.75C587.343 121.442 588.281 122.288 590.156 122.288C592.051 122.288 593.655 121.78 594.968 120.765V117.512C593.615 117.313 592.263 117.213 590.911 117.213Z",
    fill: "url(#paint26_linear_4679_872)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M584.604 119.795C584.604 116.581 586.707 114.974 590.911 114.974C592.263 114.974 593.615 115.074 594.968 115.273V113.795C594.968 111.994 593.571 111.094 590.778 111.094C589.179 111.094 587.541 111.343 585.863 111.84V109.601C587.541 109.104 589.179 108.855 590.778 108.855C595.397 108.855 597.706 110.477 597.706 113.721V124.526H596.167L595.219 122.974C593.67 124.009 591.982 124.526 590.156 124.526C586.455 124.526 584.604 122.949 584.604 119.795ZM590.911 117.213C588.533 117.213 587.343 118.059 587.343 119.75C587.343 121.442 588.281 122.288 590.156 122.288C592.051 122.288 593.655 121.78 594.968 120.765V117.512C593.615 117.313 592.263 117.213 590.911 117.213Z",
    fill: "#1F1F1F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M613.9 121.332C614.976 121.87 616.175 122.138 617.498 122.138C621.021 122.138 622.783 120.183 622.783 116.273C622.783 112.86 621.031 111.154 617.527 111.154C616.146 111.154 614.937 111.273 613.9 111.512V121.332ZM611.161 109.497C613.224 109.069 615.356 108.855 617.557 108.855C622.837 108.855 625.477 111.338 625.477 116.303C625.477 121.785 622.822 124.526 617.513 124.526C616.269 124.526 615.065 124.278 613.9 123.78V130.198H611.161V109.497Z",
    fill: "url(#paint27_linear_4679_872)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M613.9 121.332C614.976 121.87 616.175 122.138 617.498 122.138C621.021 122.138 622.783 120.183 622.783 116.273C622.783 112.86 621.031 111.154 617.527 111.154C616.146 111.154 614.937 111.273 613.9 111.512V121.332ZM611.161 109.497C613.224 109.069 615.356 108.855 617.557 108.855C622.837 108.855 625.477 111.338 625.477 116.303C625.477 121.785 622.822 124.526 617.513 124.526C616.269 124.526 615.065 124.278 613.9 123.78V130.198H611.161V109.497Z",
    fill: "#1F1F1F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M649.666 108.855V111.094H644.188V124.526H641.449V111.094H635.972V108.855H649.666Z",
    fill: "url(#paint28_linear_4679_872)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M649.666 108.855V111.094H644.188V124.526H641.449V111.094H635.972V108.855H649.666Z",
    fill: "#1F1F1F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M669.487 124.631C663.269 124.292 660.16 121.656 660.16 116.721C660.16 111.746 663.269 109.089 669.487 108.751V103.184H672.211V108.736C678.429 109.044 681.538 111.706 681.538 116.721C681.538 121.695 678.429 124.337 672.211 124.646V130.198H669.487V124.631ZM669.487 122.377V111.004C665.183 111.333 663.032 113.208 663.032 116.631C663.032 120.123 665.183 122.039 669.487 122.377ZM672.211 110.989V122.392C676.514 122.093 678.665 120.173 678.665 116.631C678.665 113.168 676.514 111.288 672.211 110.989Z",
    fill: "url(#paint29_linear_4679_872)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M669.487 124.631C663.269 124.292 660.16 121.656 660.16 116.721C660.16 111.746 663.269 109.089 669.487 108.751V103.184H672.211V108.736C678.429 109.044 681.538 111.706 681.538 116.721C681.538 121.695 678.429 124.337 672.211 124.646V130.198H669.487V124.631ZM669.487 122.377V111.004C665.183 111.333 663.032 113.208 663.032 116.631C663.032 120.123 665.183 122.039 669.487 122.377ZM672.211 110.989V122.392C676.514 122.093 678.665 120.173 678.665 116.631C678.665 113.168 676.514 111.288 672.211 110.989Z",
    fill: "#1F1F1F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M693.497 116.691C693.497 111.367 696.063 108.706 701.196 108.706C706.328 108.706 708.894 111.367 708.894 116.691C708.894 122.014 706.328 124.675 701.196 124.675C696.083 124.675 693.517 122.014 693.497 116.691ZM696.236 116.631C696.236 120.501 697.889 122.437 701.196 122.437C704.502 122.437 706.155 120.501 706.155 116.631C706.155 112.84 704.502 110.945 701.196 110.945C697.889 110.945 696.236 112.84 696.236 116.631Z",
    fill: "url(#paint30_linear_4679_872)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M693.497 116.691C693.497 111.367 696.063 108.706 701.196 108.706C706.328 108.706 708.894 111.367 708.894 116.691C708.894 122.014 706.328 124.675 701.196 124.675C696.083 124.675 693.517 122.014 693.497 116.691ZM696.236 116.631C696.236 120.501 697.889 122.437 701.196 122.437C704.502 122.437 706.155 120.501 706.155 116.631C706.155 112.84 704.502 110.945 701.196 110.945C697.889 110.945 696.236 112.84 696.236 116.631Z",
    fill: "#1F1F1F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M721.594 124.526V108.855H724.333V115.422H732.549V108.855H735.288V124.526H732.549V117.661H724.333V124.526H721.594Z",
    fill: "url(#paint31_linear_4679_872)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M721.594 124.526V108.855H724.333V115.422H732.549V108.855H735.288V124.526H732.549V117.661H724.333V124.526H721.594Z",
    fill: "#1F1F1F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M751.778 108.855V124.526H749.039V108.855H751.778ZM751.778 103.184V105.795H749.039V103.184H751.778Z",
    fill: "url(#paint32_linear_4679_872)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M751.778 108.855V124.526H749.039V108.855H751.778ZM751.778 103.184V105.795H749.039V103.184H751.778Z",
    fill: "#1F1F1F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4679_872",
    x1: 179.322,
    y1: 61.3848,
    x2: 754.054,
    y2: 48.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4679_872",
    x1: 188.475,
    y1: 117.497,
    x2: 751.608,
    y2: 76.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1E88F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4679_872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.612,
    height: 108.325,
    fill: "white",
    transform: "translate(16.8867 22.752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f38a32988a821e1570810601e01da441.svg";
export { ForwardRef as ReactComponent };